module.exports = __webpack_public_path__ + "static/media/not_found.283754f3.png";